import React from 'react'
import { Field, reduxForm } from 'redux-form'

// VALIDATION

const requiredInvisible = value => value ? undefined : 'Required'

class LoginFormInputField extends React.Component{

  
	constructor(){
		super()
		this.state={
			showPassword:false, 
		}
	}  
 
	render(){  

		const {input, styleName} = this.props

		return(
			<div 
				className={'signin-form-field' + 
				(styleName ? ` signin-form-field--${styleName} ` : '') + 
				(input.value !== '' ? ' signin-form-field--nonEmpty ' : ' signin-form-field--empty')				
				}
			>
		 
				{styleName === 'email' &&
				<input 
					{...input}
					className='signin-form-field-input'          
					name='email'
					placeholder='Email Address'
					type='text'
					autoComplete='email'
				/>
				}

				{styleName === 'password' &&
				<React.Fragment>
					<input 
						{...input} 
						className='signin-form-field-input'
						name='password'          
						placeholder='Password'
						autoComplete='current-password'
						type={this.state.showPassword ? 'text' : 'password' }
					/>
					
					<div className='signin-form-field--password-showPassword' onClick={()=>{this.setState({showPassword: !this.state.showPassword})}}>
						{this.state.showPassword && 
							<span>Hide</span>
						}
						{!this.state.showPassword && 
							<span>Show</span>
						}
					</div>
				</React.Fragment>
				}
			</div>
		)
	}
}



class LoginForm extends React.Component{

	render(){
		const { handleSubmit,loginError,submitLoading } = this.props


		return(
				
			<form 
				className={'signin-form ' + 
						(this.props.anyTouched ? ' signin-form--anyTouched ' : '') +
						(this.props.valid ? ' signin-form--valid ' : ' signin-form--invalid')
				 }
				onSubmit={handleSubmit}
			 >
				
				<Field 
					name="email" 
					type="text"
					styleName='email'
					validate={requiredInvisible}
					component={LoginFormInputField}                         
				/>
				
				<Field
					name="password"
					type="password"
					styleName='password'
					validate={requiredInvisible}
					component={LoginFormInputField}         
				/>

				<button className="signin-form-submitBtn" type="submit"> 
					
					{!submitLoading &&	
						<React.Fragment>
						Sign in
						</React.Fragment>
					}

					{submitLoading &&
					<div className='signin-form-submitBtn-loadingSpinnerContainer'>
						<div className='signin-form-submitBtn-loadingSpinner' />
					</div>
					}
				</button>                             

				{loginError &&
					<div className='signup-form-error'>   
						{loginError}
					</div> 
				}

			</form>         
		)
	}
}



LoginForm = reduxForm({
	form: 'loginForm' 
})(LoginForm)

export default LoginForm


